import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import {
    hideSupplementalMediaView,
    setMedia,
    nextMedia,
    onInfoIconClicked,
    onVideoViewed,
    onVideoFullScreen,
    onPanoLoaded,
    onShareClicked,
} from '../supplementalMediaActions'
import { LoadingIndicator } from 'aria-viewer/loadingscreen'
import { KEY_CODES, MEDIA_MODULE_TYPES } from 'aria-viewer/tour/constants/'
import { forceMediaPause } from 'aria-viewer/interactive-element/actions/common.js'
import { AccessibilityController } from '../../../legacy'
import $ from 'jquery'
import { getEnv } from 'aria-viewer/utils/environment'
import { IframeCommunication } from 'aria-viewer/common'

class SupplementalMediaDesktop extends PureComponent {
    constructor(props) {
        super(props)

        this.state = {
            visible: false,
            loading: false,
        }

        this.handleOnMessage = this.handleOnMessage.bind(this)
    }

    handleOnMessage = e => {
        const {
            setMedia,
            nextMedia,
            onInfoIconClicked,
            onVideoViewed,
            onVideoFullScreen,
            onPanoLoaded,
            forceMediaPause,
            mediaListByType: { panoramas, photos, videos },
            supplementalMediaVisible,
        } = this.props

        const [functionName, params] = (typeof e.data == 'string' && e.data.split(':')) || [null, null]

        switch (functionName) {
            case 'onReady':
                const iframe = this.refs.iframe

                if (iframe) {
                    if (supplementalMediaVisible) {
                        const mediaType =
                            panoramas.length > 0
                                ? MEDIA_MODULE_TYPES.PANOS
                                : photos.length > 0
                                ? MEDIA_MODULE_TYPES.PHOTOS
                                : MEDIA_MODULE_TYPES.VIDEOS

                        const iframeData = {
                            title: this.props.currentStop.title || '',
                            totalPanos: panoramas.length,
                            totalPhotos: photos.length,
                            totalVideos: videos.length,
                            id: this.props.currentStop.stopid,
                            panos: { total: panoramas.length },
                            videos: { total: videos.length },
                            photos: { total: photos.length },
                            mediaType,
                        }

                        iframe.contentWindow.postMessage(`standalone:${JSON.stringify(iframeData)}`, '*')
                    }
                }
                break
            case 'onMediaType':
                setMedia({
                    mediaType: params.substr(0, params.length - 1), //singular,
                    tinyurl: '',
                    smallurl: '',
                    mediumurl: '',
                    largeurl: '',
                })
                break
            case 'onNextMedia':
                nextMedia()
                break
            case 'onInfoIconClicked':
                onInfoIconClicked()
                break
            case 'onVideoPlayed':
                onVideoViewed()
                break
            case 'onVideoFullScreen':
                onVideoFullScreen()
                break
            case 'onPanoLoaded':
                onPanoLoaded()
                break
            case 'onClose':
                forceMediaPause(false)
                this.close()
                break
            default:
                break
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            this.props.supplementalMediaVisible &&
            this.props.supplementalMediaVisible != prevProps.supplementalMediaVisible
        ) {
            this.standalone()
            AccessibilityController.modalShown('#supplemental_media_view')
        } else if (!this.props.supplementalMediaVisible) {
            AccessibilityController.modalDismissed('#supplemental_media_view')
        }
    }

    standalone = () => {
        const iframe = this.refs.iframe

        if (iframe) this.setState({ visible: true, loading: false })
    }

    close = () => {
        this.setState({ visible: false })

        setTimeout(() => {
            this.props.hideSupplementalMediaView()
        }, 300)
    }

    getIframeURL = ({ loc_id, owner_id, tourid, areShareButtonsEnabled }) => {
        return `${getEnv(
            'REACT_APP_BASE_URL'
        )}/standalone?loc_id=${loc_id}&inst_id=${owner_id}&tourid=${tourid}&shareOn=${areShareButtonsEnabled}`
    }

    render() {
        const {
            tourid,
            location: { owner_id, loc_id },
            areShareButtonsEnabled,
        } = this.props

        const url = this.getIframeURL({ loc_id, owner_id, tourid, areShareButtonsEnabled })
        if (!owner_id || !loc_id || !this.props.supplementalMediaVisible) return null
        return (
            <div
                id="supplemental_media_view"
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    zIndex: 5000,
                    transform: 'translate3d(0,0,1px)',
                }}
                aria-label="Supplemental media view presented"
                aria-live="assertive"
            >
                <div
                    style={{
                        opacity: this.state.loading ? 1 : 0,
                        transition: '300ms opacity',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        width: 200,
                        height: 200,
                        transform: 'translate(-50%,-50%)',
                    }}
                >
                    <LoadingIndicator class="gray" />
                </div>
                <IframeCommunication onReceiveMessage={this.handleOnMessage} targetOrigin="*">
                    <iframe
                        className="supplementalMediaFrame"
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            transition: '300ms opacity',
                            opacity: this.state.visible ? 1 : 0,
                            border: 0,
                        }}
                        allowFullScreen={true}
                        ref="iframe"
                        onLoad={this.standalone}
                        alt="Supplemental Media Panel"
                        title="Supplemental Media Panel"
                        src={url}
                    />
                </IframeCommunication>
            </div>
        )
    }
}

export default connect(
    mapSelectorsToProps([
        'location',
        'currentStop',
        'mediaListByType',
        'supplementalMediaVisible',
        'tourid',
        'areShareButtonsEnabled',
    ]),
    {
        hideSupplementalMediaView,
        setMedia,
        nextMedia,
        onInfoIconClicked,
        onVideoViewed,
        onVideoFullScreen,
        onPanoLoaded,
        onShareClicked,
        forceMediaPause,
    }
)(SupplementalMediaDesktop)
